export default {
    "title": "Lista de ejecuciones de datos",
    "description": "Actualizar datos desde el webservice",
    "success": "CORRECTO",
    "button": "Obtener datos",
    "error": "ERROR",
    "manual": "MANUAL",
    "automatic": "AUTOMATICO",
    "running": "EN CURSO",
    "executionsTableColumns": {
        "startTime": "Fecha de inicio",
        "finishTime": "Fecha de fin",
        "duration": "Duración",
        "type": "Tipo",
        "status": "Estado",
        "user": "Usuario"
    },
    "runningExecution": "Ya hay una ejecución en marcha. Por favor espera a que termine.",
};